"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_group_1 = __importDefault(require("./form-group"));
__export(require("./form-group"));
exports.default = form_group_1.default;
//# sourceMappingURL=index.js.map